import { configuration } from '../../../app/common-reducers.js';
import { applyDidYouMeanCorrection, disableAutomaticQueryCorrection, enableDidYouMean, setCorrectionMode, } from '../../../features/did-you-mean/did-you-mean-actions.js';
import { hasQueryCorrectionSelector } from '../../../features/did-you-mean/did-you-mean-selectors.js';
import { didYouMeanReducer as didYouMean } from '../../../features/did-you-mean/did-you-mean-slice.js';
import { loadReducerError } from '../../../utils/errors.js';
import { buildController, } from '../../controller/headless-controller.js';
/**
 * The DidYouMean controller is responsible for handling query corrections.
 * When a query returns no result but finds a possible query correction, the controller either suggests the correction or
 * automatically triggers a new query with the suggested term.
 *
 * @param engine - The headless engine.
 * @param props - The configurable `DidYouMean` controller properties.
 * @returns A `DidYouMean` controller instance.
 *
 * @group Controllers
 * @category DidYouMean
 */
export function buildCoreDidYouMean(engine, props = {}) {
    if (!loadDidYouMeanReducers(engine)) {
        throw loadReducerError;
    }
    const controller = buildController(engine);
    const { dispatch } = engine;
    dispatch(enableDidYouMean());
    if (props.options?.automaticallyCorrectQuery === false) {
        dispatch(disableAutomaticQueryCorrection());
    }
    dispatch(setCorrectionMode(props.options?.queryCorrectionMode || 'next'));
    const getState = () => engine.state;
    const hasQueryCorrection = () => hasQueryCorrectionSelector(getState().didYouMean);
    return {
        ...controller,
        get state() {
            const state = getState();
            return {
                originalQuery: state.didYouMean.originalQuery,
                wasCorrectedTo: state.didYouMean.wasCorrectedTo,
                wasAutomaticallyCorrected: state.didYouMean.wasAutomaticallyCorrected,
                queryCorrection: state.didYouMean.queryCorrection,
                hasQueryCorrection: hasQueryCorrection(),
            };
        },
        applyCorrection() {
            dispatch(applyDidYouMeanCorrection(this.state.queryCorrection.correctedQuery));
        },
        updateQueryCorrectionMode(queryCorrectionMode) {
            dispatch(setCorrectionMode(queryCorrectionMode));
        },
    };
}
function loadDidYouMeanReducers(engine) {
    engine.addReducers({ configuration, didYouMean });
    return true;
}
